// extracted by mini-css-extract-plugin
export default {"cls1":"VeloCardAction_cls1__nA+ve","cls2":"VeloCardAction_cls2__VeYKp VeloCardAction_cls1__nA+ve"};